import classNames from 'classnames/bind';
import styles from './FormInput.module.scss';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

let cx = classNames.bind(styles);

function errorText(error, name, label) {
	if (error[name].type === 'required') {
		return !error[name].message ? 'Required' : error[name].message;
	} else {
		return !error[name].message ? `Invalid ${label}` : error[name].message;
	}
}

export function FormInput({ label, type = 'text', id, required, className, minLength, maxLength, min, max, pattern, name, checked, value, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const [isFocused, setIsFocused] = useState(false);
	const handleFocus = () => setIsFocused(true);
	const handleBlur = () => setIsFocused(false);

	let registerInput = function (string, registerOptions) {
		return;
	};
	let formStateObj;
	if (useFormContext()) {
		const { register, formState } = useFormContext();
		formStateObj = formState;
		registerInput = register;
	}

	function setPattern() {
		if (type === 'email' && pattern?.value === null) {
			return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
		} else if (pattern?.value === null) {
			return null;
		} else {
			return new RegExp(pattern?.value, 'i');
		}
	}

	const registerOptions = {
		required: required,
		maxLength: maxLength,
		minLength: minLength,
		min: min,
		max: max,
		pattern: {
			value: pattern ? setPattern() : null,
			message: pattern ? pattern?.message : null,
		},
		onBlur: handleBlur,
	};

	return (
		<div className={cx(['ns_input-container', 'input-container', `input-type-${type}`, isFocused && 'in-focus', formStateObj?.errors?.[name] && 'error', formStateObj?.dirtyFields?.[name] && 'dirty', ...classNameArray])}>
			{label && <label className={cx(['ns_label', 'label'])} htmlFor={id} dangerouslySetInnerHTML={{ __html: label + (required?.value ? '*' : '') }} />}
			<input className={cx(['ns_input', 'input'])} type={type} id={id} {...registerInput(name, registerOptions)} aria-describedby={`${id}-help`} onFocus={handleFocus} {...props} defaultValue={value} defaultChecked={checked} />
			{formStateObj?.errors?.[name] && (
				<small role="alert" id={`${id}-help`} className={cx(['input-error'])}>
					{errorText(formStateObj?.errors, name, label)}
				</small>
			)}
		</div>
	);
}
